<template>
  <f7-page no-toolbar no-navbar no-swipeback class="pt-0">
    <f7-page-content class="dark-bg">
      <div class="block h-100 no-margin">
        <div class="row h-100">
          <div class="col-100 medium-50 large-40 margin-left-auto margin-right-auto align-self-center text-align-center padding-vertical">
            <p class="text-align-center mb-0">
              <img :src="require('@/assets/kos.logo.white.png')" alt="Logo" class="logo">
            </p>
            <h2 class="text-align-center mt-0 mb-0 text-color-white font-open">TINH HOA LÀNG SỐ</h2>
            <f7-block strong class="mb-0" inset>
              <f7-list inset class="mb-2">
                <f7-list-input
                    type="text"
                    placeholder="Tài khoản"
                    :value="username"
                    @input="username = $event.target.value"
                >
                  <f7-icon ios="f7:person" slot="media"></f7-icon>
                </f7-list-input>
                <f7-list-input
                    type="password"
                    placeholder="Mật khẩu"
                    pattern="[0-9]{8}"
                    inputmode="numeric"
                    maxlength="8"
                    :value="password"
                    @input="password = $event.target.value"
                >
                  <f7-icon ios="f7:lock" slot="media"></f7-icon>
                </f7-list-input>
              </f7-list>
              <f7-button fill color="red" @click.prevent="login" class="mb-2">ĐĂNG NHẬP</f7-button>
              <f7-row class="margin-top">
                <f7-col class="text-align-left">
                  <f7-link href="/quen-mat-khau" class="text-color-gray">Quên mật khẩu?</f7-link>
                </f7-col>
                <f7-col class="text-align-right">
                  <f7-link href="/dang-ky" class="text-color-gray">Tạo tài khoản mới</f7-link>
                </f7-col>
              </f7-row>
              <p class="text-align-center">
                -----------
              </p>
              <f7-row>
                <f7-col>
                  <f7-button fill color="telegram" icon-ios="f7:paperplane_fill" icon-size="18px" external target="_blank" href="https://t.me/kiotso">
                    Telegram 24/7
                  </f7-button>
                </f7-col>
                <f7-col>
                  <f7-button fill color="yellow" icon-ios="f7:bubble_left_bubble_right" icon-size="18px" href="/livechat">
                    LiveChat
                  </f7-button>
                </f7-col>
              </f7-row>
            </f7-block>
            <p class="text-align-center text-color-white-opacity text-small mt-1">v{{ $store.state.app_version }}</p>
            <h5 class="text-align-center mt-1 mb-0 text-color-white font-open">
              HỘI TỤ : CÔNG NGHỆ - KỸ NĂNG - KIỂM SOÁT<br/> Lấp đầy khoảng trống kinh nghiệm của bạn
            </h5>
          </div>
        </div>
      </div>
    </f7-page-content>
  </f7-page>
</template>
<script>

export default {
  data(){
    return {
      username:'',
      password:'',
    };
  },
  methods:{
    login(){
      const app = this.$f7;

      app.dialog.preloader();

      this.$store.dispatch('login', {
        username:this.username,
        password:this.password
      }).then(() => {
        app.dialog.close();
        this.$f7.views.main.router.navigate('/dashboard');
      }).catch((err) => {
        app.dialog.close();
        app.dialog.alert(err, 'LỖI!');
      });
    },
  },
};
</script>
<style scoped>
.font-open{
  font-family : 'Quicksand', sans-serif !important;
}
img.logo {
  height : 72px;
}
.text-color-white-opacity{
  color: rgba(238, 235, 235, 0.8) !important;
}
.text-small{
  font-size: 12px;
}
.color-telegram {
  --f7-theme-color       : #25A4E2;
  --f7-theme-color-rgb   : 37, 164, 226;
  --f7-theme-color-shade : #1E8FC6;
  --f7-theme-color-tint  : #25A7E7;
}
</style>
